import React from "react";
import { Mic } from "lucide-react";
import { ANNOUNCER_PRESETS } from "../DirectorMixerRack";

/**
 * ConsoleAnnouncerFx — 2×N preset grid that applies an announcer-vox
 * effect to the host mic. Extracted from DirectorConsole's monitors
 * column so the page stays small.
 *
 * @param {Object} props
 * @param {string} props.activeKey     Currently-applied preset key (from nowPlaying.announcer).
 * @param {Fn}     props.onSelect      (presetKey) => void — calls broadcasterProxy.setAnnouncer.
 */
export default function ConsoleAnnouncerFx({ activeKey, onSelect }) {
  return (
    <div
      data-testid="monitors-announcer-fx"
      className="mt-1 bg-black/40 border border-sky-400/30 rounded-lg p-2"
    >
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider font-black text-sky-300 mb-2">
        <Mic className="w-3 h-3" /> Announcer FX
      </div>
      <div className="grid grid-cols-2 gap-1">
        {ANNOUNCER_PRESETS.map((p) => {
          const active = activeKey === p.key;
          return (
            <button
              key={p.key}
              data-testid={`monitors-announcer-${p.key}`}
              onClick={() => onSelect?.(p.key)}
              className={`text-[10px] font-black rounded py-1.5 transition border ${
                active
                  ? "bg-sky-500 text-white border-sky-400"
                  : "bg-white/5 border-white/10 text-white/70 hover:bg-white/10"
              }`}
            >
              {p.label}
            </button>
          );
        })}
      </div>
      <div className="text-[9px] text-white/40 italic mt-1.5">Applies to your live mic</div>
    </div>
  );
}
